###
# Элемент списка
###
App.ClientsTableRowComponent = Em.Component.extend
  env: Em.inject.service('environment')

  tagName: 'tr'
  classNames: ['clients-table-row']
  
  isBonusEnabled: false

  # Свойства
  client: null

  avatarBackground: (->
    return unless @get('client.avatar')
    "background-image: url(#{@get('client.avatar')})".htmlSafe()
  ).property('client')


  hasTags: (->
    !!@get('client.client_tags')
  ).property('client')


  recurrenceLabel: (->
    @get('env').translate("clients.recurrence_label.#{@get('client.recurrence')}")
  ).property('client.recurrence')


  lastOrderAt: (->
    date = @get('client.last_order_at')
    if date?
      moment(date).fromNow()
    else
      # todo i18n
      'неизвестно когда'
  ).property('client.last_order_at')


  averageCheck: (->
    numeral(@get('client.average_check')).format('0,0')
  ).property('client.average_check')

  bonusCount: (->
    bonusCount = Number (@get('client.bonus.amount'))
    return Em.I18n.t 'c.client_card.bonuses.none' if bonusCount is 0
    Em.I18n.t 'c.client_card.bonuses', count: bonusCount.toFixed(0)
  ).property('client.bonus.amount')

  totalAverageCheck: (->
    numeral(@get('client.total_average_check')).format('0,0')
  ).property('client.total_average_check')


  # Actions
  openClientDialog: ( (e) ->
    return if Em.$(e.target).closest('.no-propagate').length
    @sendAction('onRowClicked', @get('client'))
  ).on('click')
